var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.79,
    height: 28.789,
    viewBox: "616 89 28.79 28.789",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 4",
    transform: "translate(4159 514)",
    clipPath: "url(\"#a\")"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3515.11-398.01h-26.09v-3.599h1.799a.9.9 0 1 0 0-1.799h-1.8v-2.699a.9.9 0 1 0 0-1.8v-2.698h1.8a.9.9 0 0 0 0-1.8h-1.8v-2.699a.9.9 0 0 0 0-1.799v-2.699h1.8a.9.9 0 1 0 0-1.8h-1.8v-2.698a.9.9 0 1 0-1.799 0v26.09c0 .992.807 1.8 1.8 1.8h26.09a.9.9 0 1 0 0-1.8Z",
    fillRule: "evenodd",
    "data-name": "Path 23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3517.81-409.706a.9.9 0 0 0 .9-.9v-4.498a.93.93 0 0 0-.017-.176c-.006-.027-.016-.052-.024-.078-.009-.03-.015-.06-.027-.09-.013-.03-.031-.059-.047-.087-.012-.023-.022-.046-.036-.067a.913.913 0 0 0-.25-.25c-.021-.014-.045-.024-.067-.036-.029-.016-.057-.033-.088-.047-.029-.012-.06-.019-.09-.028-.026-.007-.05-.017-.077-.023a.959.959 0 0 0-.176-.017h-4.499a.9.9 0 1 0 0 1.799h2.327l-8.624 8.624-2.063-2.063a.9.9 0 0 0-1.272 0l-4.499 4.499a.9.9 0 1 0 1.273 1.272l3.862-3.862 2.063 2.062a.9.9 0 0 0 1.272 0l9.26-9.26v2.327a.9.9 0 0 0 .9.9Z",
    fillRule: "evenodd",
    "data-name": "Path 24"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0V0z",
    "data-name": "Rectangle 83",
    transform: "translate(-3544 -426)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.341e19fe2dd6232c5bc758f30b584922.svg";
export { ForwardRef as ReactComponent };